document.addEventListener('DOMContentLoaded', function() {
    var container = document.querySelector('.typing-container');
    var elements = container.querySelectorAll('.typing');
    var started = false; // Para evitar múltiples ejecuciones
  
    function startTyping() {
      if (started) return;
      started = true;
  
      elements.forEach(function(el) {
        var text = el.getAttribute('data-text');
        el.innerHTML = ''; // Limpiamos el contenido
  
        var index = 0;
        var speed = 50; // Velocidad entre letras
        var interval = setInterval(function() {
          if (index < text.length) {
            var char = text.charAt(index);
            if (char === '\n') {
              // Si es un salto de línea, añadimos <br>
              el.appendChild(document.createElement('br'));
            } else {
              // Creamos un span para la letra, con la clase neon
              var span = document.createElement('span');
              span.textContent = char;
              span.classList.add('neon-char');
              el.appendChild(span);
            }
            index++;
          } else {
            clearInterval(interval);
          }
        }, speed);
      });
    }
  
    // Intersection Observer para iniciar la animación al entrar en pantalla
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          startTyping();
        }
      });
    }, { threshold: 0.1 });
  
    observer.observe(container);
  });
  